import React, { useState } from 'react';

import { Button, FormHelperText, Stack, Typography } from '@mui/material';

import OtpInput from 'react-otp-input';

import * as yup from 'yup';

import Axios from '../../../Assets/Axios/Axios';

import { COLORS } from '../../../Constant/COLORS';

import { useToastContext } from '../../../Context/ToastContext';

import { generateMaskedEmail } from './../../../Helpers/contactInformationMasker';

import { VerifyCode } from '../../../Server/Query';

import { useFormContext } from './FormContext';

function VerificationCode() {
  const { inputs, nextStep, emailOtpReferenceId } = useFormContext();
  const { showToastMessage } = useToastContext();

  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState(null);

  function handleChange(value) {
    setVerificationCode(value);
  }

  async function handleSubmit(event) {
    // try {
    //   event.preventDefault();
    //   const code = await schema.validate(verificationCode);

    //   const query = VerifyCode({
    //     code,
    //     referenceId: emailOtpReferenceId.current,
    //   });
    //   const response = await Axios({ query });

    //   if (response.errors) {
    //     showToastMessage('Something went wrong,Failed to verify your code');
    //     return undefined;
    //   }

    //   if (response.data.VerifyCode.status === 'failed') {
    //     setError('Incorrect verification code');
    //     return undefined;
    //   }

    //   nextStep();
    // } catch (error) {
    //   if (error instanceof yup.ValidationError) {
    //     setError(error.message);
    //     return undefined;
    //   }
    //   showToastMessage('Something went wrong');
    // }
  }

  return (
    <Stack
      sx={{
        px: 16,
        py: 10,
        alignItems: 'center',
        gap: 2,
        justifyContent: 'center',
      }}
      component='form'
      onSubmit={handleSubmit}
    >
      <Typography
        textAlign='center'
        fontWeight={600}
        variant='h6'
        variantMapping={{ h6: 'h1' }}
      >
        Verify Email
      </Typography>
      <Typography textAlign='center'>
        Code is sent to {generateMaskedEmail(inputs.email)}
      </Typography>

      <OtpInput
        inputStyle={{
          backgroundColor: COLORS.grey9,
          width: '40px',
          aspectRatio: '1',
          border: 'none',
          borderRadius: '4px',
          boxShadow: '4px 4px 7px -1px rgba(0, 0, 0, 0.15)',
          fontSize: '1.5em',
        }}
        containerStyle={{ gap: '1em' }}
        shouldAutoFocus
        isInputNum
        numInputs={5}
        value={verificationCode}
        onChange={handleChange}
      />

      <FormHelperText error={error} sx={{ textAlign: 'center' }}>
        {error}
      </FormHelperText>

      <Button type='submit' color='blue' sx={{ color: 'white', mt: 1, px: 4 }}>
        Submit
      </Button>
    </Stack>
  );
}

const schema = yup.string().required().length(5).label('OTP');

export default VerificationCode;
